import { combineReducers } from "redux";
import { ACTIONS } from "../../_config";

import loaderReducer from "./loaderReducer";
import userReducer from "./userReducer";
import dialogReducer from "./dialogReducer";
import masterReducer from "./masterReducer";
import categoriesReducer from "./categoriesReducer";
import productsReducer from "./productsReducer";
import unitsReducer from "./unitsReducer";
import brandsReducer from "./brandsReducer";
import attributesReducer from "./attributesReducer";
import tagsReducer from "./tagsReducer";
import vendorsReducer from "./vendorsReducer";
import customerReducer from "./customerReducer";
import userManagementReducer from "./userManagementReducer";
import giftCardsReducer from "./giftCardsReducer";
import ordersReducer from "./ordersReducer";
import marketingReducer from "./marketingReducer";
import inventoryReducer from "./inventoryReducer";

const appReducer = combineReducers({
    loader: loaderReducer,
    user: userReducer,
    dialog: dialogReducer,
    master: masterReducer,
    categories: categoriesReducer,
    products: productsReducer,
    units: unitsReducer,
    brands: brandsReducer,
    attributes: attributesReducer,
    tags: tagsReducer,
    vendors: vendorsReducer,
    customers: customerReducer,
    userManagement: userManagementReducer,
    giftCards: giftCardsReducer,
    orders: ordersReducer,
    marketing: marketingReducer,
    inventory: inventoryReducer,
});

const rootReducer = (state: any, action: any) => {
    if (action.type === ACTIONS.USER.LOGOUT) {
        state = undefined;
        localStorage.removeItem("persist:root");
    }

    return appReducer(state, action);
};

export default rootReducer;
